import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell, { TruncatedLink } from "../../../components/TruncatedCell";
import onboardingService from "../../../services/onboardings";
import { instanceToken } from "../../../utils/constant";

export default function Onboardings() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [onboardings, setOnboardings] = useState(null);

  useEffect(() => {
    fetchOnboarding(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchOnboarding = async (limit, offset) => {
    try {
      const res = await onboardingService.getOnboardings(
        instanceToken.token,
        limit,
        offset
      );
      parse(res.data);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    setOnboardings(data.startup_images);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const openDetail = (row) => navigate(`/onboardings/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "name_en",
      label: "Name (English)",
      render: (row) => <TruncatedCell value={row.name_en} />,
    },
    {
      id: "name_mm",
      label: "Name (Myanmar)",
      render: (row) => <TruncatedCell value={row.name_mm} myanmar />,
    },
    {
      id: "description",
      label: "Description (English)",
      render: (row) => <TruncatedCell value={row.description} />,
    },
    {
      id: "description_mm",
      label: "Description (Myanmar)",
      render: (row) => <TruncatedCell value={row.description_mm} myanmar />,
    },
    {
      id: "link",
      label: "Link",
      render: (row) => (
        <TruncatedLink href={row.link} value={row.link} />
      ),
    },
  ];

  return (
    <DataListPage
      title="Onboarding"
      rows={onboardings || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{
        label: "Create",
        onClick: () => navigate("/createOnboarding"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!onboardings}
    />
  );
}
